import React from 'react';

const NebulaOrdersFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaOrdersModalRegistry = {
    personalize_nebulaOrdersId: NebulaOrdersFormModal
};
export default nebulaOrdersModalRegistry;
